import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import React from 'react';

import { AccountService } from '@sm360/widget-commons-general';
import { Quote } from '@sm360/widget-commons-vehicle';

import 'build-and-quote/components/HeaderMessage/HeaderMessage.scss';

class HeaderMessage extends React.Component {
    constructor(props) {
        super(props);

        this.saveToGarage = this.saveToGarage.bind(this);
    }

    saveToGarage(newAccount) {
        if (AccountService.isAuthenticated()) {
            const { saveToGarage } = this.props;
            if (saveToGarage) {
                saveToGarage(newAccount);
            }
        }
        return true;
    }

    render() {
        const { message, saveToGarage, quote } = this.props;
        return (
            <div className="HeaderMessage--content is-bold">
                <icon className="icon-Crochet" />
                {message}
                {saveToGarage && (
                    <Quote.AddToGarageButton
                        buttonClass="is-alternate"
                        quote={quote}
                        role="button"
                        tabIndex={0}
                        onClick={this.saveToGarage}
                    />
                )}
            </div>
        );
    }
}

HeaderMessage.propTypes = {
    message: PropTypes.string.isRequired,
    quote: PropTypes.instanceOf(Quote.QuoteModel).isRequired,
    saveToGarage: PropTypes.func.isRequired,
};

HeaderMessage.displayName = 'HeaderMessage';

function mapStateToProps(state) {
    return {
        purchaseMethods: state.purchaseMethods,
        quote: state.quote,
    };
}

export { HeaderMessage };
export default connect(mapStateToProps)(HeaderMessage);
